
import styles from './CriteraNotMet.module.scss';
export default function KeymastersPotCriteraNotMet() {

	return <div className='flex flex-col items-center'>
		<h1 className="text-[40px] m-0 text-center max-[1000px]:mb-5 max-[700px]:text-[32px] max-[500px]:text-[24px]">YOU ARE NOT A KEYMASTER</h1>
		<div className={`w-auto font-bold text-xl  text-center pt-4 pb-4 pl-3 pr-3 -f-family-burbank  max-[500px]:text-lg ${styles['criteria-not-met-box']}`}>SORRY, CRITERIA NOT MET</div>
	</div>;
}
